import React from "react";
import { checkIsValidHTML } from "../utils";
import * as DOMpurify from "dompurify"

export interface StatusHistoryBoxProps {
  comment: string;
  date_created: string;
  status: string;
  ticket_id: number;
}

const StatusHistoryBx = ({
  status,
  date_created,
  comment,
}: StatusHistoryBoxProps) => {
  return (
    <div className="status-history-bx" style={{ marginBottom: "2rem" }}>
      <div className="status-bx status-item-1">
        <div className="bold-text">Status</div>
        <div className="status">{status}</div>
      </div>

      <div className="status-item-2">
        <h4>Date & Time</h4>
        <p>{date_created}</p>
      </div>

      <div className="status-item-3">
        <h4>Comment</h4>
        {checkIsValidHTML(comment) ? (
          <p dangerouslySetInnerHTML={{__html: DOMpurify.sanitize(comment)}} />
        ) : (
          <p>{comment}</p>
        )}
      </div>
    </div>
  );
};

export default StatusHistoryBx;
